module.exports = __webpack_public_path__ + "media/bootstrap-icons/lock-48f6b7d2.svg";